/* global angular */

require('../accounts-table/accounts-table.component')

angular.module('AemTransparentAccount')
  .component('search', {
    template: require('./search.component.tpl.html'),
    controller: SearchCtrl,
    controllerAs: 'vm',
    bindings: {}
  })

SearchCtrl.$inject = ['$location', '$routeParams', '$timeout']

function SearchCtrl ($location, $routeParams, $timeout) {
  var vm = this

  vm.$onInit = function () {
    vm.keyword = $routeParams.keyword
    vm.keywordChanged = keywordChanged
    $timeout(function () {
      document.querySelector('[data-widget="AemTransparentAccount"]').scrollIntoView(true)
    })
  }

  function keywordChanged () {
    if (vm.keyword) {
      var accountNumber = vm.keyword.split('/')
      $location.path('/keyword/' + accountNumber[0])
    } else {
      $location.path('/')
    }
  }
}
